import {useEffect, useState} from "react";
import "./singleTicketOpenLocalSite.scss";
import {Link, useParams} from "react-router-dom";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import useFetch from "../../../hooks/useFetch";
import {formatDate} from "../../../helper/helper";
import CommentSection from "../../../components/comentarLocalSite/CommentSection";

const SingleOpenTicketLocalSite = () => {
  const [ticketOpen, setTicketOpen] = useState([]);
  const { ticketId } = useParams();
  const { data, loading, error } = useFetch(`/ticketsite/${ticketId}`);

  useEffect(() => {
    setTicketOpen(data);
  }, [data]);

  console.log(ticketOpen)

const dateTicket = () => {
  const dateCreated =  formatDate(ticketOpen.created_at);
  const dateUpdate = formatDate(ticketOpen.updated_at);
  const downTime = formatDate(ticketOpen.down_time);
  const start_pending = formatDate(ticketOpen.start_pending);
    const start_pending2 = formatDate(ticketOpen.start_pending2);
    const end_pending = formatDate(ticketOpen.end_pending);
    const end_pending2 = formatDate(ticketOpen.end_pending2);

  let UpTime;
    if (ticketOpen.up_time === 0) {
        UpTime = "Not Available";
    } else {
        UpTime = formatDate(ticketOpen.up_time);
    }
  const date = {
    create_at : dateCreated,
    updated_at: dateUpdate,
      down_time : downTime,
      up_time: UpTime,
      start_pending: start_pending,
      start_pending2: start_pending2,
      end_pending: end_pending,
      end_pending2: end_pending2,

  }
  return date;
}
const date = dateTicket()





  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          {loading ? (
              "loading"
          ) : (
              <div className="left">
                  <Link to={`/ticketsite/update/${ticketOpen.id}`} style={{textDecoration: "none"}}>
                      <div className="editButton">Edit</div>
                  </Link>
                  <div>
                      <Link to={`/ticketsite/update/time/${ticketOpen.id}`} style={{textDecoration: "none"}}>
                          <div className="createButton">Update TT Aging</div>
                      </Link>
                  </div>


                  <div>
                      <Link to={`/ticketsite/pending/time/${ticketOpen.id}`} style={{textDecoration: "none"}}>
                          <div className="createPending">Update Time Pending</div>
                      </Link>
                  </div>

                  <div>
                      <Link to={`/ticketlocal/mass/${ticketOpen.id}`} style={{textDecoration: "none"}}>
                          <div className="createMass">Create Gamas</div>
                      </Link>
                  </div>


                  <h1 className="title"></h1>
                  <div className="item">
                      <img
                          src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                          alt=""
                          className="itemImg"
                      />
                      <div className="details">
                          <h1 className="itemTitle">Information Open Ticket B2C Local Site</h1>
                          <table className="detailsTable">
                              <tbody>
                              <tr>
                                  <td className="itemKey">Ticket ID</td>
                                  <td className="itemValue">: {ticketOpen.id}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Site Customer</td>
                                  <td className="itemValue">: {ticketOpen.customer_site}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">POP ID</td>
                                  <td className="itemValue">: {ticketOpen.pop_id}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Root Cause</td>
                                  <td className="itemValue">: {ticketOpen.root_cause}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Action</td>
                                  <td className="itemValue">: {ticketOpen.action}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Vendor Id</td>
                                  <td className="itemValue">: {ticketOpen.vendor_id}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Down Time</td>
                                  <td className="itemValue">: {date.down_time}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Up Time</td>
                                  <td className="itemValue">: {date.up_time}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Status ID</td>
                                  <td className="itemValue">: {ticketOpen.status_id}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Category ID</td>
                                  <td className="itemValue">: {ticketOpen.category_id}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Region ID</td>
                                  <td className="itemValue">: {ticketOpen.region_id}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Start Pending</td>
                                  <td className="itemValue">: {date.start_pending}</td>
                              </tr>

                              <tr>
                                  <td className="itemKey">End Pending</td>
                                  <td className="itemValue">: {date.end_pending}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Start Pending 2</td>
                                  <td className="itemValue">: {date.start_pending2}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">End Pending 2</td>
                                  <td className="itemValue">: {date.end_pending2}</td>
                              </tr>


                              <tr>
                                  <td className="itemKey">Created AT </td>
                                  <td className="itemValue">: {date.create_at}</td>
                              </tr>
                              <tr>
                                  <td className="itemKey">Last Updated AT </td>
                                  <td className="itemValue">: {date.updated_at}</td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>)}
        </div>
          <div className="bottom">
              <div className="details">
              <h1 className="itemTitle">Notifikasi Link Down</h1>
                  <br/>
                  <table className="detailsTable">
                      <tbody>
                      <tr>
                          <td className="itemKey">Ticket ID</td>
                          <td className="itemValue">: {ticketOpen.id}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Vendor </td>
                          <td className="itemValue">: {ticketOpen.vendor_id}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Site Customer</td>
                          <td className="itemValue">: {ticketOpen.customer_site}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">POP ID</td>
                          <td className="itemValue">: {ticketOpen.pop_id}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Root Cause</td>
                          <td className="itemValue">: {ticketOpen.root_cause}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Action</td>
                          <td className="itemValue">: {ticketOpen.action}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">DOWN Time</td>
                          <td className="itemValue">: {date.down_time}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">UP Time</td>
                          <td className="itemValue">: {date.up_time}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Duration </td>
                          <td className="itemValue">: {ticketOpen.estimation}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Status ID</td>
                          <td className="itemValue">: {ticketOpen.status_id}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Region ID</td>
                          <td className="itemValue">: {ticketOpen.region_id}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Created AT</td>
                          <td className="itemValue">: {date.create_at}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Start Pending</td>
                          <td className="itemValue">: {date.start_pending}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">End Pending</td>
                          <td className="itemValue">: {date.end_pending}</td>
                      </tr>

                      <tr>
                          <td className="itemKey">Start Pending 2</td>
                          <td className="itemValue">: {date.start_pending2}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">End Pending 2</td>
                          <td className="itemValue">: {date.end_pending2}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">Last Updated AT</td>
                          <td className="itemValue">: {date.updated_at}</td>
                      </tr>
                      <tr>
                          <td className="itemKey">LOG:</td>
                          <td className="itemValue">
                              <br/>
                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <br/>
                  <br/>
              </div>
              <CommentSection ticketId={ticketId}/>
              <br/>
              <br/>
              <br/>

          </div>
      </div>
    </div>
  );
};

export default SingleOpenTicketLocalSite;
